import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    addNewMediaIntoReport,
    addNewGroupAtLast,
    addNewItemAtLast,
    addNewRoomAtLast,
    getReportById,
    removeMediaFromReport,
    deleteRoomFromReport,
    deleteGroupFromReport,
    deleteItemFromReport,
    updateRoomInReport,
    updateGroupInReport,
    updateItemInReport,
    resetReportUpdateObject,
    recordImageDeletedAsUpdate,
    uploadImages,
    resetDataQueuedInAPI,
    addNewKeyIntoReport,
    updateKeyInReport,
    deleteKeyInReport,
    setKeyImage,
    addNewAlarm,
    updateAlarmInReport,
    deleteAlarmInReport,
    addNewReceipt,
    updateReceiptInReport,
    deleteReceiptInReport,
    addNewMeter,
    updateMeterInReport,
    deleteMeterInReport,
    handleReadingDeleteInMeter,
    handleReadingUpdate,
    addNewReadingToMeter,
    loadNewRoomTemplate,
    loadAIData,
    loadSaveState,
    addNewDisclaimer,
    updateDisclaimerInReport,
    deleteDisclaimerInReport,
    addNewDisclaimerMedia,
    removeMediaFromDisclaimer,
    updateAdditionalSummaryDetailsInReport,
    logErrorResponse,
    setSelectedOverlayImage,
    updateOverlayImageList,
    updateMeterAbsenceInfo,
} from '../actions/report_action';

export default function ReportContainer(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getReportById,
        addNewRoomAtLast,
        addNewGroupAtLast,
        addNewItemAtLast,
        addNewMediaIntoReport,
        removeMediaFromReport,
        deleteRoomFromReport,
        deleteGroupFromReport,
        deleteItemFromReport,
        updateRoomInReport,
        updateGroupInReport,
        updateItemInReport,
        resetReportUpdateObject,
        recordImageDeletedAsUpdate,
        uploadImages,
        resetDataQueuedInAPI,
        addNewKeyIntoReport,
        updateKeyInReport,
        deleteKeyInReport,
        setKeyImage,
        addNewAlarm,
        updateAlarmInReport,
        deleteAlarmInReport,
        addNewReceipt,
        updateReceiptInReport,
        deleteReceiptInReport,
        addNewMeter,
        updateMeterInReport,
        updateMeterAbsenceInfo,
        deleteMeterInReport,
        handleReadingDeleteInMeter,
        handleReadingUpdate,
        addNewReadingToMeter,
        loadNewRoomTemplate,
        loadAIData,
        loadSaveState,
        addNewDisclaimer,
        updateDisclaimerInReport,
        deleteDisclaimerInReport,
        addNewDisclaimerMedia,
        removeMediaFromDisclaimer,
        updateAdditionalSummaryDetailsInReport,
        logErrorResponse,
        setSelectedOverlayImage,
        updateOverlayImageList
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        successStatus: state.report.successStatus,
        statusMessage: state.report.responseMessage,
        reportDetails: state.report.reportDetails,
        isFetching: state.report.isFetching,
        reportUpdates: state.report.reportUpdates,
        mediaAttachments: state.report.attachment,
        change: state.report.change,
        updateKeys: state.report.reportUpdateKeys,
        updateMeters: state.report.reportUpdateMeters,
        updateAlarms: state.report.reportUpdateAlarms,
        updateReceipts: state.report.reportUpdateReceipts,
        updateDisclaimer:state.report.reportUpdateDisclaimer,
        errorResponse:state.report.errorResponse,
        roomErrorResponse:state.report.roomErrorResponse,
        overlayImage:state.report.overlayImage,
        overlayImageList:state.report.overlayImageList
    };
}



// WEBPACK FOOTER //
// ./src/containers/report_container.js